import { axiosInstanceAuth } from "../../Utils/AxiosInstance";
import { handleApiError } from "../../Utils/handleApiError";

export const ResetPasswordApi = async data => {
  let snackBarData = {};
  try {
    const response = await axiosInstanceAuth.post("Auth/ResetPassword", data);

    snackBarData = {
      type: response?.data.IsSuccess ? "success" : "error",
      message: response?.data?.Message,
      openToast: true,
    };

    return { ...response, snackBarData };
  } catch (error) {
    // snackBarData = {
    //   type: "error",
    //   message: error?.response?.data?.Message || error?.message,
    //   openToast: true,
    // };
    const snackBarData = handleApiError(error);
    return { ...error?.response, snackBarData };
  }
};
